<template>
    <div class="catalog-nav mt-0 pt-0">
        <div class="row">
            <div class="col-12">
                <ul v-for="filterGroup in catalogStore.filters" class="nav flex-column pb-3">
                    <li v-if="filterGroup.items?.length" class="nav-item">
                        <p class="text-uppercase mb-1">{{filterGroup.group_name}}
                            <!--                            <a class="ms-4 text-lowercase badge" v-if="filtersSelected[filterGroup.name]" @click.prevent="removeFilter(filterGroup.name)" href="#">{{ $t('catalog.reset') }}</a>-->
                        </p>
                    </li>

                    <template v-if="filterGroup.type === 'radio'">
                        <li class="nav-item">
                            <div class="form-check" v-if="filterGroup.items?.length > 0">
                                <input class="form-check-input catalog-filter-item" :name="filterGroup.name" type="radio"
                                       :id="id('filters-' + filterGroup.name + '-0')"
                                       :checked="isFilterSelected(filterGroup.name, {id: -1})"
                                       @change="toggleFilter(filterGroup.name, {id: -1})">
                                <label class="form-check-label" :for="id('filters-' + filterGroup.name + '-0')">{{$t('global.any')}}</label>
                            </div>
                            <div v-for="item in filterGroup.items?.slice(0, hideMoreThan) ?? []" class="form-check">
                                <input class="form-check-input catalog-filter-item" :name="filterGroup.name" type="radio"
                                       :id="id('filters-' + filterGroup.name + '-' + item.id)"
                                       :checked="isFilterSelected(filterGroup.name, item)"
                                       @change="toggleFilter(filterGroup.name, item)">
                                <label class="form-check-label" :for="id('filters-' + filterGroup.name + '-' + item.id)">{{item.name}}</label>
                            </div>
                        </li>
                    </template>

                    <template v-if="filterGroup.type === 'checkbox'">
                        <li class="nav-item">
                            <div v-for="item in filterGroup.items?.slice(0, hideMoreThan) ?? []" class="form-check">
                                <input class="form-check-input catalog-filter-item" type="checkbox"
                                       :id="id('filters-' + filterGroup.name + '-' + item.id)"
                                       :checked="isFilterSelected(filterGroup.name, item)"
                                       @change="toggleFilter(filterGroup.name, item)">
                                <label class="form-check-label" :for="id('filters-' + filterGroup.name + '-' + item.id)">{{item.name}}</label>
                            </div>
                        </li>

                        <li class="nav-item" v-if="filterGroup.items?.length > hideMoreThan">
                            <ul class="nav flex-column mt-1 collapse" :id="id(filterGroup.name + '_children')">
                                <li v-for="item in filterGroup.items?.slice(hideMoreThan) ?? []" class="nav-item">
                                    <div class="form-check">
                                        <input class="form-check-input catalog-filter-item" type="checkbox"
                                               :id="id('filters-' + filterGroup.name + '-' + item.id)"
                                               :checked="isFilterSelected(filterGroup.name, item)"
                                               @change="toggleFilter(filterGroup.name, item)">
                                        <label class="form-check-label" :for="id('filters-' + filterGroup.name + '-' + item.id)">{{item.name}}</label>
                                    </div>
                                </li>
                            </ul>
                            <ul class="nav flex-column pb-3">
                                <li class="nav-item">
                                    <a class="view-more text-uppercase collapsed" data-bs-toggle="collapse" :href="'#' + id(filterGroup.name + '_children')" role="button" aria-expanded="false" :aria-controls="id(filterGroup.name + '_children')">
                                        <span class="collapsed">{{ $t('catalog.view_more') }}</span>
                                        <span class="expanded">{{ $t('catalog.view_less') }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </template>
                    <li class="nav-item w-75 pb-3" v-if="filterGroup.name === 'metal_ids'">
                        <WeightFilter :init-range="weightRange" @onChange="applyWeightFilter"/>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="floating-button-container d-md-none d-block">
                <button @click="catalogStore.toggleMobileSearch" class="btn w-75 btn-primary floating-button">
                    <template v-if="catalogStore.products.length > 0">
                        {{ $t('catalog.search_results', {count: catalogStore.products.length})}}
                    </template>
                    <template v-else>
                        {{ $t('catalog.no_results')}}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>


<script setup>
const WeightFilter = defineAsyncComponent(() => import('~/components/Catalog/WeightFilter.vue'));

const props = defineProps({
    weightRange: {
        type: [Object],
        default: () => ({
            min: 0,
            max: 100
        })
    },
});

const router = useRouter();
const route = useRoute();
const hideMoreThan = 10;

const catalogStore = useCatalogStore();

const emit = defineEmits(['filter-applied']);

const isFilterSelected = (group, item) => {
    if (!item || item.id === undefined || item.id === null) {
        return false;
    }

    if (catalogStore.filtersSelected[group]) {
        const selectedFilters = catalogStore.filtersSelected[group];

        const selectedArray = Array.isArray(selectedFilters) ? selectedFilters : [selectedFilters];

        return selectedArray.some(element =>
            element === item.id || element.toString() === item.id.toString()
        );
    }

    return item.id === -1;
}

const toggleFilter = (group, item) => {
    const filterGroup = catalogStore.filters.find(f => f.name === group);
    const originalGroup = group;
    const queryGroup = group + '[]';

    let newQuery = {};

    Object.keys(catalogStore.filtersSelected).forEach(key => {
        const values = catalogStore.filtersSelected[key];
        if (values && values.length > 0) {
            newQuery[key + '[]'] = Array.isArray(values) ? values : [values];
        }
    });

    const currentVal = catalogStore.filtersSelected[originalGroup];

    let values = [];
    if (currentVal) {
        values = Array.isArray(currentVal) ? [...currentVal] : [currentVal];
    }

    const itemStr = item.id.toString();

    if (filterGroup.type === 'radio') {
        if (item.id === -1) {
            values = [];
            delete newQuery[queryGroup];
        } else {
            values = [itemStr];
            newQuery[queryGroup] = values;
        }
    } else {
        const index = values.findIndex(val => val === itemStr || val.toString() === itemStr);

        if (index > -1) {
            values.splice(index, 1);
        } else {
            values.push(itemStr);
        }

        if (values.length > 0) {
            newQuery[queryGroup] = values;
        } else {
            delete newQuery[queryGroup];
        }
    }

    catalogStore.filtersSelected[originalGroup] = values;

    if (filterGroup.type === 'radio') {
        router.push({path: route.path, query: newQuery });
    }

    emit('filter-applied', newQuery);
};

const applyWeightFilter = (values, unit) => {
    delete route.query['weight_range_oz'];
    delete route.query['weight_range_g'];
    delete catalogStore.catalog.filters_selected['weight_range_oz'];
    delete catalogStore.catalog.filters_selected['weight_range_g'];
    const newQuery = { ...route.query };

    const queryName = `weight_range_${unit}`;
    if (values) {
        newQuery[queryName] = values.join(',');
        catalogStore.catalog.filters_selected[queryName] = values.join(',');
    } else {
        delete newQuery[queryName];
    }
    emit('filter-applied', newQuery);
};

const id = str => str.trim().replace(/\s+/g, '-');
</script>
